import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { PointsServiceDetail } from '@components/templates/marketplace';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';

export function PointsServiceDetailPage() {
    const { uuid } = useParams();
    const { pointsServiceDetail, allSettings } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('points-service-detail-component.metatags.title', { marketplace: allSettings?.data?.marketplaceName }),
        description: t('points-service-detail-component.metatags.description', {
            name: pointsServiceDetail?.data?.name,
            marketplace: allSettings?.data?.marketplaceName,
        }),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        image: pointsServiceDetail?.data?.image
            ? {
                  src: pointsServiceDetail?.data?.image?.src ?? '',
                  alt: pointsServiceDetail?.data?.name ?? '',
                  type: pointsServiceDetail?.data?.image?.type,
                  height: pointsServiceDetail?.data?.image?.height,
                  width: pointsServiceDetail?.data?.image?.width,
              }
            : undefined,
        url: SITE_URLS.pointsServiceDetail.replace(':uuid', `${uuid}`),
        index: true,
    });

    return <PointsServiceDetail />;
}
